import { render } from "./CertificationsView.vue?vue&type=template&id=3bd02e48"
import script from "./CertificationsView.vue?vue&type=script&lang=js"
export * from "./CertificationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__